import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_PROVIDER,
  screenData: data,
});
//  error msg dispatch function
export const dispatchErrorMsgProvider = (data) => ({
  type: actionTypes.GET_ERROR_MSG_PROVIDER,
  payload: data,
});
// error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(dispatchErrorMsgProvider([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgProvider([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
//refresh data
export const refreshBProviderClaims = () => ({
  type: actionTypes.SET_REFRESH_DATA_PROVIDER,
  payload: {},
});
export const refreshBProviderClaimsDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_PROVIDER_DISPLAY,
  payload: {},
});
export const dispatchDisplayObjBProvider = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_PROVIDER,
  payload: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_LIST_PROVIDER,
  payload: data,
});
//on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_PROVIDER,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
export const dispatchFrom = (data) => ({
  type: actionTypes.GET_FROM,
  payload: data,
});
export const dispatchProvider = (data) => ({
  type: actionTypes.GET_PROVIDER,
  payload: data,
});

//get Provider
export const getProvider = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_BProvider, value)
    .then((response) => {
      if (response.data.providerClaims340BVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchProvider(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchProvider([]));
    });
};
//API call for the result grid of the Institutional Claims unit tyoe
export const getReferenceDataProviderClaims = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_REFERENCE_DATA}`, values)
    .then((response) => {
      return dispatch({
        type: actionTypes.GET_REFERENCE_DATA_PROVIDER_CLAIMS,
        referenceData: response.data,
      });
    })
    .catch((response) => {
      dispatch([]);
      return response;
    });
};
